import React, { memo } from 'react';
import '../../Common/Filters/Filters.css';
import MultipleSelect from '../../Common/Filters/MultipleSelect';
import { useCensusFiltersContext } from './Filters/hooks/useCensusFiltersContext';

const CityFilter = ({ className = '' }) => {
    const { filters, cities, onFilterChange } = useCensusFiltersContext();

    return (
        <div className={`filtros-container-dashboards ${className}`}>
            <MultipleSelect
                label="Cidade"
                options={cities}
                onChange={onFilterChange}
                name="cidade"
                className="select-cidade-dashboards"
                defaultValue={filters.cidade}
            />
        </div>
    );
};

export default memo(CityFilter);
